<div id="button-control-geolocation">
    <button mat-mini-fab color="primary" (click)="onClick()" aria-label="Geolocalización">
        <mat-icon id="mylocation">my_location</mat-icon>
    </button>
</div>